import React from 'react';  
import FloatingLabelInput from './floatingLabelInput';

export const ToggleButton = ({ label,  isToggled, handleToggle, name}) => {
    return (
      <div className="flex items-center justify-between gap-3">
        <div>
            <span className="text-sm font-medium text-[#211b4f]">
                  {label}
            </span>
        </div>
        <div className='flex flex-none items-center gap-2'>
          <label htmlFor={`${label}-${name}`} className="cursor-pointer">
            <div className="relative">
              <input
                id={`${label}-${name}`}
                type="checkbox"
                className="sr-only"
                checked={isToggled}
                onChange={handleToggle}
              />
              <div className={`block h-6 w-11 rounded-full transition-colors ${isToggled ? 'bg-[#fb6635]' : 'bg-slate-300'}`}></div>
              <div
                className={`dot absolute left-1 top-1 h-4 w-4 rounded-full bg-white shadow-sm transition-transform ${
                  isToggled ? 'translate-x-5' : ''
                }`}
              ></div>
            </div>
          </label>
          <span className={`w-8 text-sm font-semibold ${isToggled ? 'text-[#fb6635]' : 'text-slate-400'}`}>
            {isToggled ? 'Yes' : 'No'}
          </span>
        </div>
      </div>
    );
  };

  const OptionalFields = ({
    handleOptionFieldChange,
    handleOptionFieldToggle,
    handleMaxCompensationToggle,
    handleMaxCompensationFieldChange,
    handleBlur,
    data,
    error,
    label,
    name,
}) => {

    return (
        <div className="border-b border-slate-100 py-3 last:border-b-0">
            <div className="flex items-center justify-start gap-3">
                {/* Toggle switch */}
                { !data.isToggleHidden && (
                    <label htmlFor={`${label}-${name}-main`} className="flex items-center cursor-pointer">
                        <div className="relative">
                            <input
                                id={`${label}-${name}-main`}
                                type="checkbox"
                                className="sr-only"
                                checked={data.isBoxToggled}
                                onChange={handleOptionFieldToggle}
                            />
                            <div className={`block h-6 w-11 rounded-full transition-colors ${data.isBoxToggled ? 'bg-[#fb6635]' : 'bg-slate-300'}`}></div>
                            <div
                                className={`dot absolute left-1 top-1 h-4 w-4 rounded-full bg-white shadow-sm transition-transform ${
                                    data.isBoxToggled ? 'translate-x-5' : ''
                                }`}
                            ></div>
                        </div>
                    </label>
                )}
                
                {/* Label text */}
                {/* Label text */}
                <span className="flex items-center gap-1.5 text-sm font-medium text-[#211b4f]">
                    {label}
                    <span className="relative group">
                        <span className="flex h-5 w-5 cursor-pointer items-center justify-center rounded-full bg-slate-100 text-[11px] font-bold text-slate-500 transition-colors hover:bg-orange-100 hover:text-[#fb6635]">
                            ?
                        </span>
                        <div className="pointer-events-none absolute left-0 bottom-full z-30 mb-2 hidden w-64 whitespace-normal rounded-lg bg-[#211b4f] p-2 text-xs leading-relaxed text-white shadow-lg group-hover:block">
                            {data.helpText || 'No information available'}
                        </div>
                    </span>
                </span>
            </div>
            
            {/* Hide Input value and compensation if toggled OFF */}
            { data.isBoxToggled && (
                <div className="mt-4 grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-6">
                    <div className="sm:col-span-3">
                        <FloatingLabelInput 
                            handleChange={handleOptionFieldChange} 
                            handleBlur={handleBlur}
                            value={data.value}
                            error={error.firstName}
                            name={name}
                            id={name}
                            label={''}
                            type='number'
                            required={true}
                        />
                    </div>
                    <div className="sm:col-span-3 mb-10 space-y-4">
                        <ToggleButton 
                            label="Is there a max compensation for this comp bucket" 
                            isToggled={data.isMaxCompensation}
                            handleToggle={handleMaxCompensationToggle}
                            name={name}
                        />
                        {data.isMaxCompensation && (
                            <FloatingLabelInput 
                                handleChange={handleMaxCompensationFieldChange} 
                                handleBlur={handleBlur}
                                value={data.maxCompensation} 
                                error={error.lastName} 
                                name={'maxCompensation ' + name} 
                                id={'maxCompensation ' + name}
                                label="value ($)" 
                                type='text'
                                required={true}
                                isCurrency={true}
                            />
                        )}
                    </div>
                </div>
            )}
        </div>
    )
}

export default OptionalFields;